export default (dva, model) => {
  const modelIndex = dva._models.findIndex((m) => m.namespace === model.namespace);
  if (modelIndex === -1) {
    dva.model(model);
  }
};
